import { RefObject, useLayoutEffect, useState } from 'react'

/**
 * Whether the element is narrower than `width` pixels, kept current as it resizes. Measured before
 * the browser paints, so a wide element never shows its narrow layout first. Until the element is
 * measured it counts as narrow.
 */
export function useIsNarrowerThan(ref: RefObject<HTMLElement | null>, width: number): boolean {
  const [isNarrower, setIsNarrower] = useState(true)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }
    const measure = (): void => setIsNarrower(element.clientWidth < width)
    measure()
    const resizeObserver = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(measure)
    resizeObserver?.observe(element)
    return () => resizeObserver?.disconnect()
  }, [ref, width])

  return isNarrower
}
